import Timeline from './components/Timeline.jsx';
import Timer from './components/Timer.jsx'

import './App.css';

function App() {
  return (
    <div className="App">
      <Timer/>
    </div>
  );
}

export default App;
